import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { MessageRememberingDialogComponent } from './message-remembering-dialog.component';

export const ngxMessageRememberingDialogModule = angular.module('ngxMessageRememberingDialogModule', [])
	.directive('ngxMessageRememberingDialog', downgradeComponent({ component: MessageRememberingDialogComponent }))
	.name;
